import { Component, OnInit, Optional } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ResultData } from 'src/app/_models/ResultData';
import { CountryService } from 'src/app/_services/country.service';
import { SearchEngineDataService } from 'src/app/_services/search-engine-data.service';
import { SyllabusService } from 'src/app/_services/syllabus.service';
import { AuthService } from './../../_services/auth.service';
import { StudentService } from './../../_services/student.service';

@Component({
  selector: 'app-country-level-syllabus-detail',
  templateUrl: './country-level-syllabus-detail.component.html',
  styleUrls: ['./country-level-syllabus-detail.component.css']
})
export class CountryLevelSyllabusDetailComponent implements OnInit {
  renderMathNow=false
  levelId=0
  is_logged_in=false
  keywords=[]
  countryFlag=""
  countryName=""
  primaryLevelNaming=""
  syllabusInfoResponse={levelimages:"",topics:[],name:"", gradeLevel:""}
  constructor(
   private route:ActivatedRoute,
   @Optional() private searchEngineDataService:SearchEngineDataService,
   private syllabusService:SyllabusService,
   private countryService:CountryService,
   private studentService:StudentService,
   private authService:AuthService
   ) { }

  ngOnInit(): void {
    this.route.params.subscribe(
      params => {
        this.levelId = +params['id']
        this.syllabusService.levelSyllabusDetail(this.levelId).subscribe({
          next: (data:ResultData) => {
            this.syllabusInfoResponse = data.rs.data
            this.initMetaData()
            this.countryService.getCountryInfoByLevel(this.levelId).subscribe({
              next: (data:ResultData) => {
                this.countryFlag = data.rs.data['countryImage']
                this.countryName = data.rs.data['name']
                this.primaryLevelNaming = data.rs.data['primaryLevelNaming']
              }
            })
          }
        }

        )
      })
      this.authService.gatePass.subscribe(
        x=>{this.is_logged_in=x.is_logged_in}
      )
  }
  renderMathPage(value:boolean){
    Promise.resolve(null).then(() => {
      this.renderMathNow=true
    })
  }

  downloadapp(){
    window.location.href = 'https://play.google.com/store/apps/details?id=com.boldungu.boldlet';
   }

   initMetaData(): void {
    if (this.searchEngineDataService) {
      this.searchEngineDataService.updateMetadata({
        title: "Boldungu " +this.syllabusInfoResponse.name,
        description: this.extractTopicNameList(),
        keywords:this.keywords,
        author:"Boldungu Team"
      });
    }
  }
  extractTopicNameList(){
    let tNames=[]
    for(let tt of this.syllabusInfoResponse.topics){
    let name=tt['name']
    tNames.push(name)
    }
    tNames.push("Mathematics syllabus")
    tNames.push("Maths resources for primary schools")
    this.keywords=tNames
    return tNames.join()
  }
}
